import { v4 as uuId } from 'uuid';

/*----------------------------
 Furnishe images
 -----------------------------*/

import furnishe from '../images/projects/furnishe/furnishe1.png';
import furnisheHome from '../images/projects/furnishe/all/home.png';
import furnisheFilter from '../images/projects/furnishe/all/filter.png';
import furnisheAddProduct from '../images/projects/furnishe/all/addProduct.png';
import furnisheAllOrders from '../images/projects/furnishe/all/allOrders.png';
import furnisheAllProducts from '../images/projects/furnishe/all/allProducts.png';
import furnisheAllUsers from '../images/projects/furnishe/all/allUsers.png';
import furnisheCart from '../images/projects/furnishe/all/cart.png';
import furnisheConfirmOrder from '../images/projects/furnishe/all/confirmOrder.png';
import furnisheDashboard from '../images/projects/furnishe/all/dashboard.png';
import furnisheDeleteReview from '../images/projects/furnishe/all/deleteReview.png';
import furnisheDetails from '../images/projects/furnishe/all/details.png';
import furnisheEditProduct from '../images/projects/furnishe/all/editProduct.png';
import furnisheEditProfile from '../images/projects/furnishe/all/editProfile.png';
import furnisheLogin from '../images/projects/furnishe/all/login.png';
import furnisheOrders from '../images/projects/furnishe/all/orders.png';
import furnisheProfile from '../images/projects/furnishe/all/profile.png';
import furnisheRegister from '../images/projects/furnishe/all/register.png';
import furnisheReset from '../images/projects/furnishe/all/reset.png';
import furnisheResetPassword from '../images/projects/furnishe/all/resetPassword.png';
import furnisheShipping from '../images/projects/furnishe/all/shipping.png';
import furnisheUpdateOrder from '../images/projects/furnishe/all/updateOrder.png';


/*-----------------------
Countries Images
-------------------------*/
import countries from '../images/projects/countries/countries1.png';
import countriesHome from '../images/projects/countries/all/home.png';
import countriesHomeDay from '../images/projects/countries/all/homeDay.png';
import countriesDetailsDay from '../images/projects/countries/all/detailsDay.png';
import countriesDetailsNight from '../images/projects/countries/all/detailsNight.png';
import countriesSearch from '../images/projects/countries/all/search.png';
import countriesFilter from '../images/projects/countries/all/filter.png';


/*------------------------
  Landing pages
 ------------------------*/
 import landingHome from '../images/projects/landing-pages/home.png';
 import landingPg1 from '../images/projects/landing-pages/all/page1.png';
 import landingPg2 from '../images/projects/landing-pages/all/page2.png';


 /*------------------------
  Landing pages
 ------------------------*/
 import portfolioHome from '../images/projects/portfolio/home.png';
 import portfolioPg1 from '../images/projects/portfolio/all/page1.png';
 import portfolioPg2 from '../images/projects/portfolio/all/page2.png';
 
 
 /*------------------------
  Exotic Apps
 ------------------------*/
 import todoHome from '../images/projects/exotic-designs/home.png';
 import exoticPg1 from '../images/projects/exotic-designs/all/page1.png';
 import exoticPg2 from '../images/projects/exotic-designs/all/page2.png';
 import exoticPg3 from '../images/projects/exotic-designs/all/page3.png';
 import exoticPg4 from '../images/projects/exotic-designs/all/page4.png';
 import exoticPg5 from '../images/projects/exotic-designs/all/page5.png';

export const allData = [
    {
        _id: uuId(),
        title: 'Furniture E-commerce',
        details: {
            name: ['furnishe'],
            category: 'e-commerce application',
            summary: 'Furnishe is a furniture store that enables user purchase their dream furnitures.It is a complete e-commerce application with features that enable users to view all furniture available, view a furniture details, add furniture to cart, add reviews to furniture, view reviews, delete logged user review, checkout and complete payment, view order progresses. etc, users can also manage their profiles. It includes a complete Admin end to handle these features. and more. Explore...',
            projectInfo: {
                date: 'December, 2020',
                client: 'None',
                tools: [
                    'html5',
                    'css3', 
                    'javascript', 
                    'react', 
                    'react-bootstrap',
                    'react-icons',
                    'redux',
                    'Node.js', 
                    'express', 
                    'mongoDB', 
                    'heroku',
                    'stripe',
                    'cloudinary',
                    'nodemailer'
                ],
                sites: ['https://furnishe.herokuapp.com/']
            },
        },
        codes: ['https://github.com/Johnpaul-Attamah/furnishe'],

        homeImg: furnishe,

        images:[
            furnisheHome,
            furnisheFilter,
            furnisheAddProduct,
            furnisheAllOrders,
            furnisheAllProducts,
            furnisheAllUsers,
            furnisheCart,
            furnisheConfirmOrder,
            furnisheDashboard,
            furnisheDeleteReview,
            furnisheDetails,
            furnisheEditProduct,
            furnisheEditProfile,
            furnisheLogin,
            furnisheOrders,
            furnisheProfile,
            furnisheRegister,
            furnisheReset,
            furnisheResetPassword,
            furnisheShipping,
            furnisheUpdateOrder
        ]
    },
    {
        _id: uuId(),
        title: 'Countries of The World',
        details: {
            name: ['countries api'],
            category: 'web application',
            summary: 'Displays countries and details using the free countries API. Viewers can See all countries from the API on the homepage, search for a country using an input field, filter countries by region, Click on a country to see more detailed information on a separate page, click through to the border countries on the detail page, toggle the color scheme between light and dark mode',
            projectInfo: {
                date: 'July, 2021',
                client: 'Frontend Mentors',
                tools: [
                    'html5',
                    'css3',
                    'react',
                    'javascript',
                    'styled-components' 
                ],
                sites: ['https://peaceful-kalam-9b16eb.netlify.app/']
            },
        },
        codes: ['https://github.com/Johnpaul-Attamah/countries-api-frontendmentors'],
        homeImg: countries,
        images:[
            countriesHome,
            countriesHomeDay,
            countriesDetailsDay,
            countriesDetailsNight,
            countriesSearch,
            countriesFilter
        ]
    },
    {
        _id: uuId(),
        title: 'Landing Pages',
        details: {
            name: [
                'page1',
                'page2'
            ],
            category: 'web application',
            summary: 'Different Landing pages for different sites, built with only html, css and Javascript. Just basic html. very responsive and ready for use.',
            projectInfo: {
                date: 'July, 2021',
                client: 'Frontend Mentors',
                tools: [
                    'html5',
                    'css3',
                    'javascript', 
                ],
                sites: [
                    'https://frosty-brown-8ffacb.netlify.app/',
                    'https://vigorous-noether-686b27.netlify.app/'
                ]
            },
        },
        codes: [
            'https://github.com/Johnpaul-Attamah/manage-landingpg-frontendmentors',
            'https://github.com/Johnpaul-Attamah/room_homepage_frontendmentors'
        ],
        homeImg: landingHome,
        images:[
            landingPg1,
            landingPg2
        ]
    },
    {
        _id: uuId(),
        title: 'Web Portfolio',
        details: {
            name: ['my portfolio'],
            category: 'web application',
            summary: 'Portfolio website to display important works',
            projectInfo: {
                date: 'may, 2021',
                client: 'Frontend Mentors',
                tools: [
                    'html5',
                    'css3',
                    'react',
                    'javascript',
                    'styled-components' 
                ],
                sites: ['https://dreamy-sinoussi-ccca6e.netlify.app/']
            },
        },
        homeImg: portfolioHome,
        images:[
            portfolioPg1,
            portfolioPg2
        ]
    },
    {
        _id: uuId(),
        title: 'Exotic Apps',
        details: {
            name: [
                'reactTodo',
                'AnalogClock',
                'TipCalculator',
                'DigitalClock'
            ],
            category: 'web application',
            summary: 'Different Web applications built with html css javascript and react',
            projectInfo: {
                date: 'December, 2020',
                client: 'Frontend Mentors, github, CodePen',
                tools: [
                    'html5',
                    'css3',
                    'javascript', 
                    'React',
                    'Styled Components'
                ],
                sites: [
                    'https://zen-clarke-982f84.netlify.app/',
                    'https://johnpaul-attamah.github.io/analogClock_ui/',
                    'https://determined-knuth-12c793.netlify.app/',
                    'https://codepen.io/BORREE/full/OJmxbga'
                ]
            },
        },
        codes: [
            'https://github.com/Johnpaul-Attamah/todo-app-frontendmentors',
            'https://github.com/Johnpaul-Attamah/analogClock_ui/',
            'https://github.com/Johnpaul-Attamah/tip-calculator',
            'https://codepen.io/BORREE/pen/OJmxbga'
        ],
        homeImg: todoHome,
        images:[
            exoticPg1,
            exoticPg2,
            exoticPg3,
            exoticPg4,
            exoticPg5,
        ]
    }
];